import Vue from 'vue';
import { overridable } from '@/core/template-engine';
import ExtSlot from '@/core/module/ExtSlot.vue';
import AppLayout from '@/layouts/AppLayout.vue';
import TheNav from '@/layouts/TheNav.vue';
import TheSidebar from '@/layouts/TheSidebar.vue';
import TheFooter from '@/layouts/TheFooter.vue';
import MobileBottomNav from '@/layouts/MobileBottomNav.vue';
import AppButton from '@/ui/AppButton.vue';
import AppIconButton from '@/ui/AppIconButton.vue';
import AppCard from '@/ui/AppCard.vue';
import FormField from '@/ui/FormField.vue';
import AppTable from '@/ui/AppTable.vue';
import AppToast from '@/ui/AppToast.vue';
import clickOutside from '@/ui/clickOutside';

// Global, template-overridable building blocks. Use them by tag
// (<the-nav />, <app-button />) — never import them directly, or a
// template override will be bypassed.
const GLOBAL_COMPONENTS = {
    AppLayout,
    TheNav,
    TheSidebar,
    TheFooter,
    MobileBottomNav,
    AppButton,
    AppIconButton,
    AppCard,
    FormField,
    AppTable,
    AppToast
};

export function installComponents() {
    Vue.component('ExtSlot', ExtSlot);
    Vue.directive('click-outside', clickOutside);
    Object.entries(GLOBAL_COMPONENTS).forEach(([name, component]) => {
        Vue.component(name, overridable(name, component));
    });
}
